import { render, staticRenderFns } from "./ConfirmationPower.vue?vue&type=template&id=f651ae80&scoped=true&"
import script from "./ConfirmationPower.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPower.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationPower.vue?vue&type=style&index=0&id=f651ae80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f651ae80",
  null
  
)

export default component.exports